import React from 'react';
import { Link } from 'react-router-dom';
import { brand } from '../data/site';

/**
 * Brand lockup — supplied Morvix mark + wordmark.
 * The supplied mark is light, so it is inverted in light mode for contrast.
 */
export function Logo({
  className,
  onClick
}: {
  className?: string;
  onClick?: () => void;
}) {
  return <Link to="/" onClick={onClick} aria-label="Morvix Graphics — home" className={`group flex items-center gap-2.5 ${className ?? ''}`} data-cursor="hover" data-id="element-320" data-mp="3v9pgqmibdtbj">
      <img src={brand.logo} alt="" aria-hidden="true" width={32} height={32} loading="eager" decoding="async" className="h-8 w-8 shrink-0 object-contain invert dark:invert-0" data-id="element-321" data-mp="rqw8mp8b1wor" />
      <span className="flex flex-col leading-none" data-id="element-322" data-mp="hvm702ltjrbi">
        <span className="font-display text-[0.95rem] font-extrabold uppercase tracking-[0.02em]" data-id="element-323" data-mp="2yhc5bx18seau">
          Morvix
        </span>
        <span className="font-mono text-[0.5rem] uppercase tracking-[0.34em] text-muted" data-id="element-324" data-mp="32lbmmhucjh59">
          Graphics
        </span>
      </span>
    </Link>;
}